import { render, staticRenderFns } from "./NtvLgn.vue?vue&type=template&id=37c06ff8&"
import script from "./NtvLgn.vue?vue&type=script&lang=js&"
export * from "./NtvLgn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports